import desktopVoucher from "../assets/voucher.webp";
import desktopBundle from "../assets/food-bundle.webp";

import mobileVoucher from "../assets/voucher-mobile.webp";
import mobileBundle from "../assets/food-bundle-mobile.webp";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LazyImage from "./commons/LazyImage";
import ReviewsTile from "./Reviews/ReviewsTile";

const QuickLinkCards = ({ isMobile, navigate }) => {
  return (
    <section className="px-lg-2 mt-0 pt-0 pb-2 pb-md-3">
      <Row className="mt-0 pt-0">
        <Col xs={4} className=" px-lg-3 mb-0 pb-0">
          <Card
            onClick={() => navigate("/vouchers")}
            className={`box-card mb-0 pb-0 ${!isMobile && " me-lg-3"}`}
            style={{ borderRadius: "0px", border: "none", cursor: "pointer" }}
          >
            <LazyImage
              src={isMobile ? mobileVoucher : desktopVoucher}
              alt="Voucher - Fresh Food Delivery"
              style={{ borderRadius: "0px", border: "none", height: "100%" }}
            />
          </Card>
        </Col>
        <Col xs={4} className=" px-lg-3 mb-0 pb-0">
          <Card
            onClick={() => navigate("/foodbundles")}
            className={`box-card mb-0 pb-0 ${!isMobile && " mx-lg-3"}`}
            style={{ borderRadius: "0px", border: "none", cursor: "pointer" }}
          >
            <LazyImage
              src={isMobile ? mobileBundle : desktopBundle}
              alt="Food Bundles - Fresh Food Delivery"
              style={{ borderRadius: "0px", border: "none", height: "100%" }}
            />
          </Card>
        </Col>
        <Col xs={4} className=" px-lg-3 mb-0 pb-0">
          <ReviewsTile
            className={`box-card mb-0 pb-0 ${isMobile ? "" : "mx-lg-3"}`}
          />
        </Col>
      </Row>
    </section>
  );
};

export default QuickLinkCards;
